import React from 'react'

function Footer() {
    return (
        
        <div>
            <p className="footer-text mt-2">All rights reserved &copy;  {new Date().getFullYear()}</p>
        </div>
    )
}

export default Footer;
